import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import selfHealingService from "@/services/SelfHealingService";
import offlineQueueService from "@/services/OfflineQueueService";

// Initialize self-healing service
selfHealingService.init();

// Initialize offline queue service
offlineQueueService.init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
